import { render, staticRenderFns } from "./DiscountInfo.vue?vue&type=template&id=7886876c&scoped=true&"
import script from "./DiscountInfo.vue?vue&type=script&lang=js&"
export * from "./DiscountInfo.vue?vue&type=script&lang=js&"
import style0 from "./DiscountInfo.vue?vue&type=style&index=0&id=7886876c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7886876c",
  null
  
)

export default component.exports